// export const empresa = 'ejemplo2';
// export const empresa = 'compart';
// export const empresa = 'vancouver';
// export const empresa = 'botanero';
// export const empresa = 'sqlsrv';
// export const empresa = 'arcos';
export const empresa = 'diesel';
// export const empresa = 'pinjaque';

export default empresa;


// WEBPACK FOOTER //
// ./src/common/functions/company.js